import { render, staticRenderFns } from "./detail-equ.vue?vue&type=template&id=6b83d8c0&scoped=true&"
import script from "./detail-equ.vue?vue&type=script&lang=js&"
export * from "./detail-equ.vue?vue&type=script&lang=js&"
import style0 from "./detail-equ.vue?vue&type=style&index=0&id=6b83d8c0&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b83d8c0",
  null
  
)

export default component.exports